import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxSearchIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M21.1368 18.7864L16.5776 14.2272C17.5688 13.0576 18.1096 11.592 18.1096 10.044C18.1096 8.30877 17.4312 6.67757 16.1992 5.45037C14.9672 4.22317 13.3296 3.54797 11.588 3.54797C9.8464 3.54797 8.2088 4.22397 6.9768 5.45037C5.7448 6.67757 5.0664 8.30877 5.0664 10.044C5.0664 10.5552 5.1256 11.0576 5.24 11.5432H3.9184C3.2144 11.5432 2.6432 12.1144 2.6432 12.8184V19.212C2.6432 19.916 3.2144 20.4872 3.9184 20.4872H10.312C11.016 20.4872 11.5872 19.916 11.5872 19.212V16.5408C13.1072 16.5408 14.548 16.0256 15.7088 15.0792L20.276 19.6464C20.3912 19.7616 20.5432 19.8248 20.7056 19.8248C20.868 19.8248 21.0208 19.7616 21.1352 19.6464C21.372 19.4096 21.372 19.024 21.1352 18.7864H21.1368ZM10.7384 19.2112C10.7384 19.4456 10.548 19.636 10.3136 19.636H3.9192C3.6848 19.636 3.4944 19.4456 3.4944 19.2112V12.8176C3.4944 12.5832 3.6848 12.3928 3.9192 12.3928H5.504C5.8272 13.2248 6.324 13.9872 6.9768 14.6368C8.0056 15.6616 9.3184 16.3016 10.7376 16.4848V19.2112H10.7384ZM13.8856 15.056C13.1736 15.38 12.3944 15.5512 11.588 15.5512C10.1112 15.5512 8.7224 14.9784 7.6784 13.9376C6.6344 12.8976 6.0592 11.5144 6.0592 10.0432C6.0592 9.79517 6.076 9.54957 6.108 9.30797H13.5456C13.7328 9.30797 13.8856 9.46077 13.8856 9.64797V15.056ZM15.4984 13.9376C15.3112 14.124 15.1136 14.2944 14.9064 14.4504V9.64797C14.9064 8.89757 14.296 8.28797 13.5464 8.28797H6.3456C6.6136 7.49117 7.0656 6.76077 7.6792 6.14877C8.7232 5.10877 10.112 4.53517 11.5888 4.53517C13.0656 4.53517 14.4544 5.10797 15.4984 6.14877C16.5424 7.18877 17.1176 8.57197 17.1176 10.0432C17.1176 11.5144 16.5424 12.8976 15.4984 13.9376Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
